/*
 * feurzi-rewards-gifts.js — Cadeaux de palier (V2)
 * Réécriture propre du 2026-07-18 (la version précédente avait accumulé des rustines).
 *
 * RÔLE — garder le panier cohérent avec les paliers configurés :
 *   • ajoute automatiquement le cadeau par défaut d'un palier dès qu'il est atteint
 *   • retire le cadeau si le panier repasse sous le seuil
 *   • laisse choisir un autre cadeau, ou aucun, via UN SEUL menu déroulant
 *
 * RÈGLES MÉTIER
 *   • le sous-total qui débloque les paliers EXCLUT les lignes cadeaux
 *     (sinon un cadeau offert déclencherait le palier suivant, en cascade)
 *   • chaque ligne cadeau porte la propriété `_palier` = seuil (ex. "49")
 *     → c'est ce marqueur qui identifie un cadeau ; la mise à 0 € est faite
 *       par la règle de réduction (Nexus), PAS par ce fichier
 *   • un refus est mémorisé dans un attribut de panier `_cadeau_refuse_<seuil>`
 *     et reste réversible (il suffit de rechoisir un cadeau dans le menu)
 *
 * PARTIS PRIS TECHNIQUES (issus d'incidents réels — voir mémoire projet)
 *   • UNE SEULE mutation par cycle : une clé de ligne devient périmée dès que le
 *     panier change, et l'utiliser ensuite fait supprimer une AUTRE ligne.
 *   • On ne cible jamais une ligne par une clé mémorisée : on relit le panier et
 *     on retrouve la ligne par son marqueur `_palier`.
 *   • Rafraîchissement via les sélecteurs de Dawn (getSectionsToRender), SANS
 *     appeler renderContents() qui rouvrirait le tiroir à chaque changement.
 *   • Aucun patch de window.fetch : la boutique héberge plusieurs apps panier,
 *     l'intercepter provoquait des boucles de requêtes.
 */
(function () {
  'use strict';

  // Le snippet est rendu deux fois par page (tiroir + page panier) : sans cette
  // garde, tout s'exécuterait en double et deux cadeaux seraient ajoutés.
  if (window.__feurziGifts) return;
  window.__feurziGifts = true;

  var AUCUN = '__aucun__';
  var PROP = '_palier';
  var PREFIXE_REFUS = '_cadeau_refuse_';

  var enCours = false; // verrou : une seule opération panier à la fois

  /* ------------------------------------------------------------------ *
   *  Lecture des données
   * ------------------------------------------------------------------ */

  function euros(cents) {
    var v = cents / 100;
    return (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  /** Paliers actifs, triés par seuil croissant. */
  function lirePaliers() {
    var noeud = document.querySelector('.feurzi-rewards2__data');
    if (!noeud) return [];
    try {
      return JSON.parse(noeud.textContent || '[]')
        .filter(function (p) {
          return p.actif !== false && Number(p.seuil) > 0;
        })
        .map(function (p) {
          p.seuilCents = Math.round(Number(p.seuil) * 100);
          return p;
        })
        .sort(function (a, b) {
          return a.seuilCents - b.seuilCents;
        });
    } catch (e) {
      console.warn('[Feürzi] Paliers illisibles :', e);
      return [];
    }
  }

  function estCadeau(item) {
    return !!(item.properties && item.properties[PROP]);
  }

  function palierDe(item) {
    return Number(item.properties[PROP]);
  }

  function estRefuse(cart, seuil) {
    return !!(cart.attributes && cart.attributes[PREFIXE_REFUS + seuil] === '1');
  }

  /** Sous-total qui débloque les paliers : tout SAUF les cadeaux. */
  function sousTotalEligible(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (!estCadeau(item)) total += item.original_line_price;
    });
    return total;
  }

  function trouverLigneCadeau(cart, seuil) {
    var trouvee = null;
    cart.items.forEach(function (item) {
      if (estCadeau(item) && palierDe(item) === Number(seuil)) trouvee = item;
    });
    return trouvee;
  }

  function trouverPalier(paliers, seuil) {
    var trouve = null;
    paliers.forEach(function (p) {
      if (Number(p.seuil) === Number(seuil)) trouve = p;
    });
    return trouve;
  }

  /* ------------------------------------------------------------------ *
   *  Accès au panier
   * ------------------------------------------------------------------ */

  function lireCart() {
    return fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) {
      return r.json();
    });
  }

  /**
   * Sections à rafraîchir sur la page courante. Chaque cible porte :
   *   • `section`   — l'identifiant DEMANDÉ à Shopify (= la clé de la réponse)
   *   • `selecteur` — le nœud du DOM à remplacer
   *   • `source`    — ce qu'on extrait du HTML renvoyé
   *
   * ⚠️ INCIDENT DU 2026-07-19 — NE JAMAIS DEMANDER UNE SECTION DE TEMPLATE JSON
   * PAR SON NOM DE FICHIER.
   *
   * Une section posée par un template JSON n'est pas identifiée par son nom de
   * fichier mais par un ID d'instance (`template--30461086925148__cart-footer`),
   * lu dans `data-id`. C'est cet ID — et lui seul — qui porte la configuration des
   * BLOCS de la section. Demandée par nom de fichier, elle revient rendue avec
   * `section.blocks` VIDE : sur `main-cart-footer`, cela supprime les blocs
   * `subtotal` et `buttons`, donc le « Total estimé » ET le bouton de paiement.
   *
   * Symptôme : après un changement de cadeau sur /cart, la barre s'affiche
   * normalement mais tout le récapitulatif a disparu — panier impossible à payer,
   * sans aucune erreur en console. Se répare seul au rechargement de la page.
   * Indice de reconnaissance : le HTML injecté porte `section-main-cart-footer-padding`
   * alors que le CSS de la page définit `section-template--…__cart-footer-padding`.
   *
   * Dawn fait la même chose de son côté (`cart.js`, getSectionsToRender) :
   *   section: document.getElementById('main-cart-footer').dataset.id
   *
   * `cart-drawer` et `cart-icon-bubble` viennent du layout et non d'un template
   * JSON : leur nom de fichier fait foi, comme chez Dawn.
   */
  function idDeSection(noeud, repli) {
    return (noeud.dataset && noeud.dataset.id) || repli;
  }

  function ciblesDeLaPage() {
    var cibles = [];
    var noeud;

    if (document.querySelector('#CartDrawer')) {
      cibles.push({section: 'cart-drawer', selecteur: '#CartDrawer', source: '#CartDrawer'});
    }

    noeud = document.querySelector('#main-cart-items');
    if (noeud) {
      cibles.push({
        section: idDeSection(noeud, 'main-cart-items'),
        selecteur: '#main-cart-items .js-contents',
        source: '.js-contents',
      });
    }

    // Indispensable : sur /cart la barre vit dans le pied de panier, au-dessus de
    // `.js-contents`. Dawn ne rafraîchit que `.js-contents`, donc si on ne demande
    // pas cette section ici, la barre reste figée sur l'état précédent.
    // Le pied est remplacé EN ENTIER (et pas seulement `.js-contents`) puisque la
    // barre est placée au-dessus de ce conteneur ; `copierClasses` reporte alors
    // `is-empty`, que Dawn pose sur la racine de la section.
    noeud = document.querySelector('#main-cart-footer');
    if (noeud) {
      cibles.push({
        section: idDeSection(noeud, 'main-cart-footer'),
        selecteur: '#main-cart-footer',
        source: '#main-cart-footer',
        copierClasses: true,
      });
    }

    if (document.querySelector('#cart-icon-bubble')) {
      cibles.push({
        section: 'cart-icon-bubble',
        selecteur: '#cart-icon-bubble',
        source: '.shopify-section',
      });
    }

    return cibles;
  }

  /**
   * Mutation unique : toutes passent par ici, et demandent le HTML des sections
   * DANS la même requête (l'état renvoyé est donc forcément cohérent ; aller le
   * rechercher séparément provoquait un affichage de panier vide périmé).
   */
  function muter(url, corps) {
    corps.sections = ciblesDeLaPage()
      .map(function (cible) {
        return cible.section;
      })
      .join(',');
    corps.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(corps),
    }).then(function (r) {
      return r.json();
    });
  }

  function ajouterCadeau(variantId, seuil) {
    var props = {};
    props[PROP] = String(seuil);
    return muter('/cart/add.js', {id: variantId, quantity: 1, properties: props});
  }

  function changerQuantite(key, quantite) {
    return muter('/cart/change.js', {id: key, quantity: quantite});
  }

  function definirRefus(seuil, refuse) {
    var attributs = {};
    attributs[PREFIXE_REFUS + seuil] = refuse ? '1' : '';
    return muter('/cart/update.js', {attributes: attributs});
  }

  /** Retire le cadeau d'un palier en relisant le panier (clé toujours fraîche). */
  function retirerCadeauDuPalier(seuil) {
    return lireCart().then(function (cart) {
      var ligne = trouverLigneCadeau(cart, seuil);
      return ligne ? changerQuantite(ligne.key, 0) : null;
    });
  }

  /* ------------------------------------------------------------------ *
   *  Rafraîchissement de l'affichage
   * ------------------------------------------------------------------ */

  function forcerRenderBarres() {
    document.querySelectorAll('rewards-bar').forEach(function (barre) {
      if (typeof barre.render === 'function') barre.render();
    });
  }

  /**
   * Applique le HTML renvoyé par la mutation.
   *
   * La liste des cibles vient de `ciblesDeLaPage()`, la MÊME que celle qui a servi
   * à construire la demande : la clé de lecture est donc forcément celle qui a été
   * demandée. C'est ce qui a manqué le 2026-07-19 — on demandait `main-cart-footer`
   * et on relisait `main-cart-footer`, cohérent en apparence, mais l'identifiant
   * demandé était le mauvais (voir `ciblesDeLaPage`).
   *
   * On n'appelle PAS drawer.renderContents() : cette méthode termine par open(),
   * ce qui rouvrirait le tiroir à chaque changement.
   */
  function appliquerSections(reponse) {
    var sections = reponse && reponse.sections;
    if (!sections) return decorer();

    ciblesDeLaPage().forEach(function (cible) {
      var html = sections[cible.section];
      if (!html) return;
      var noeud = document.querySelector(cible.selecteur);
      if (!noeud) return;
      try {
        var source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(cible.source);
        if (source) {
          noeud.innerHTML = source.innerHTML;
          if (cible.copierClasses) noeud.className = source.className;
        }
      } catch (e) {
        console.warn('[Feürzi] Section non appliquée :', cible.section, e);
      }
    });

    forcerRenderBarres();
    return decorer();
  }

  /* ------------------------------------------------------------------ *
   *  Interface : étiquette sur la ligne + menu de choix dans la barre
   * ------------------------------------------------------------------ */

  /**
   * Le menu déroulant est le SEUL contrôle : les cadeaux, puis « Je ne veux pas
   * de cadeau » en dernière option. Multiplier les boutons créait de la confusion.
   */
  function construireMenu(palier, variantChoisi, refuse) {
    var menu = document.createElement('select');
    menu.className = 'feurzi-gift__select';

    palier.cadeaux.forEach(function (cadeau) {
      var option = document.createElement('option');
      option.value = String(cadeau.variantId);
      option.textContent = cadeau.title;
      if (!refuse && String(cadeau.variantId) === String(variantChoisi)) option.selected = true;
      menu.appendChild(option);
    });

    if (palier.sansCadeau) {
      var refus = document.createElement('option');
      refus.value = AUCUN;
      refus.textContent = 'Je ne veux pas de cadeau';
      if (refuse) refus.selected = true;
      menu.appendChild(refus);
    }

    menu.addEventListener('change', function () {
      menu.disabled = true; // retour visuel immédiat pendant l'opération
      if (menu.value === AUCUN) refuserCadeau(palier.seuil);
      else choisirCadeau(palier.seuil, menu.value);
    });
    return menu;
  }

  /*
   * ⛔ `habillerLignes()` SUPPRIMÉE (2026-07-18) — NE PAS LA RECRÉER.
   * Elle repérait la ligne du cadeau par sa POSITION dans le panier, ce qui se
   * décalait dès que la cliente achetait aussi le produit offert : l'étiquette
   * atterrissait sur la ligne payante et la vraie ligne cadeau gardait son
   * sélecteur de quantité. Le marquage est désormais fait CÔTÉ SERVEUR par Liquid
   * (classe `feurzi-gift-line` + étiquette), dans cart-drawer.liquid et
   * main-cart-items.liquid : Shopify sait exactement quelle ligne est un cadeau.
   */

  /**
   * Menu de choix, à POSITION FIXE dans la barre, pour chaque palier débloqué —
   * qu'un cadeau soit sélectionné ou refusé. Le placer sur la ligne du produit le
   * faisait disparaître puis réapparaître ailleurs quand le cadeau était refusé.
   */
  function afficherChoix(cart, paliers) {
    var base = sousTotalEligible(cart);
    document.querySelectorAll('rewards-bar').forEach(function (barre) {
      /*
       * Recalage sur le panier RÉEL avant tout affichage.
       *
       * `data-cart-total` est écrit par le serveur au rendu de la section. Il ne
       * vaut donc que tant que personne d'autre ne touche au panier. Or les apps
       * tierces (Essential Upsell, Bundles…) modifient le panier par leurs propres
       * appels, sans re-rendre nos sections : l'attribut reste alors figé sur l'état
       * précédent et la jauge annonce un montant périmé — alors que les blocs de
       * choix, eux, sont justes puisqu'ils viennent de `/cart.js`.
       *
       * On aligne donc l'attribut sur le panier réel à chaque passage. La barre
       * devient ainsi autocorrectrice, quelle que soit l'app qui a modifié le panier.
       */
      if (String(barre.dataset.cartTotal) !== String(base)) {
        barre.dataset.cartTotal = base;
        if (typeof barre.render === 'function') barre.render();
      }

      barre.querySelectorAll('.feurzi-gift-choice').forEach(function (vieux) {
        vieux.remove();
      });

      paliers.forEach(function (palier) {
        if (base < palier.seuilCents) return; // palier pas encore atteint
        if (!palier.cadeaux || !palier.cadeaux.length) return; // palier livraison seule

        var ligne = trouverLigneCadeau(cart, palier.seuil);
        var bloc = document.createElement('div');
        bloc.className = 'feurzi-gift-choice';

        var titre = document.createElement('div');
        titre.className = 'feurzi-gift__label';
        titre.textContent = '🎁 Ton cadeau palier ' + euros(palier.seuilCents);
        bloc.appendChild(titre);
        bloc.appendChild(
          construireMenu(palier, ligne ? ligne.variant_id : null, estRefuse(cart, palier.seuil)),
        );
        barre.appendChild(bloc);
      });
    });
  }

  /**
   * Redessine l'interface. Retourne bien une promesse (chaînage fiable).
   * `decorationEnCours` neutralise l'observateur pendant nos propres écritures,
   * sinon il se redéclencherait en boucle sur nos ajouts.
   */
  var decorationEnCours = false;

  /*
   * Rattrapage : la barre a disparu du DOM alors que le panier n'est plus vide.
   *
   * Sur un panier vide, la barre n'est pas rendue (`unless cart == empty`). Si une
   * app tierce le re-remplit ensuite sans re-rendre nos sections, il n'y a plus
   * aucun <rewards-bar> à recaler et la jauge reste absente jusqu'au prochain
   * chargement de page. On redemande donc la section à Shopify dans ce seul cas.
   *
   * `barreDejaVue` empêche de tenter ce rattrapage sur les pages où la barre
   * n'existe légitimement pas (aucun palier configuré → repli sur la barre V1),
   * ce qui provoquerait une requête inutile à chaque modification du panier.
   */
  var barreDejaVue = false;
  var rapatriementEnCours = false;

  function rapatrierSections() {
    var liste = ciblesDeLaPage().map(function (cible) {
      return cible.section;
    });
    if (!liste.length) return Promise.resolve(null);
    return fetch(window.location.pathname + '?sections=' + liste.join(','))
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        return {sections: sections};
      });
  }

  function decorer() {
    return lireCart()
      .then(function (cart) {
        if (document.querySelector('rewards-bar')) barreDejaVue = true;

        if (
          barreDejaVue &&
          !rapatriementEnCours &&
          cart.item_count > 0 &&
          !document.querySelector('rewards-bar')
        ) {
          rapatriementEnCours = true;
          return rapatrierSections()
            .then(function (reponse) {
              if (reponse) return appliquerSections(reponse);
            })
            .then(function () {
              rapatriementEnCours = false;
            });
        }

        var paliers = lirePaliers();
        decorationEnCours = true;
        afficherChoix(cart, paliers);
      })
      .catch(function (e) {
        console.warn('[Feürzi] Décoration impossible :', e);
      })
      .then(function () {
        setTimeout(function () {
          decorationEnCours = false;
        }, 50);
      });
  }

  /* ------------------------------------------------------------------ *
   *  Actions déclenchées par la cliente
   * ------------------------------------------------------------------ */

  function choisirCadeau(seuil, variantId) {
    if (enCours) return;
    enCours = true;
    retirerCadeauDuPalier(seuil)
      .then(function () {
        return definirRefus(seuil, false);
      })
      .then(function () {
        return ajouterCadeau(Number(variantId), seuil);
      })
      .then(appliquerSections)
      .catch(function (e) {
        console.warn('[Feürzi] Changement de cadeau impossible :', e);
      })
      .then(function () {
        enCours = false;
      });
  }

  function refuserCadeau(seuil) {
    if (enCours) return;
    enCours = true;
    // Retrait D'ABORD (clé fraîche), refus mémorisé ENSUITE : l'ordre inverse
    // périmait la clé et supprimait une autre ligne du panier.
    retirerCadeauDuPalier(seuil)
      .then(function () {
        return definirRefus(seuil, true);
      })
      .then(appliquerSections)
      .catch(function (e) {
        console.warn('[Feürzi] Refus impossible :', e);
      })
      .then(function () {
        enCours = false;
      });
  }

  /* ------------------------------------------------------------------ *
   *  Synchronisation panier ↔ paliers
   * ------------------------------------------------------------------ */

  function synchroniser() {
    if (enCours) return Promise.resolve();
    var paliers = lirePaliers();
    if (!paliers.length) return Promise.resolve();
    enCours = true;

    return lireCart()
      .then(function (cart) {
        var base = sousTotalEligible(cart);
        var action = null;

        // 1) Cadeau devenu illégitime (palier non atteint / supprimé), ou en double
        cart.items.some(function (item) {
          if (!estCadeau(item)) return false;
          var palier = trouverPalier(paliers, palierDe(item));
          if (!palier || base < palier.seuilCents) {
            action = changerQuantite.bind(null, item.key, 0);
            return true;
          }
          if (item.quantity > 1) {
            action = changerQuantite.bind(null, item.key, 1);
            return true;
          }
          return false;
        });

        // 2) Palier atteint, non servi et non refusé → ajouter le cadeau par défaut
        if (!action) {
          paliers.some(function (palier) {
            if (base < palier.seuilCents) return false;
            if (!palier.cadeaux || !palier.cadeaux.length) return false;
            if (estRefuse(cart, palier.seuil)) return false;
            if (trouverLigneCadeau(cart, palier.seuil)) return false;
            action = ajouterCadeau.bind(null, palier.cadeaux[0].variantId, palier.seuil);
            return true;
          });
        }

        // UNE SEULE mutation par cycle : les clés des autres lignes seraient
        // périmées juste après. Le cycle suivant traitera la mutation suivante.
        if (!action) return decorer();
        return action().then(function (reponse) {
          enCours = false; // libéré avant relance, sinon le cycle suivant est ignoré
          return appliquerSections(reponse).then(synchroniser);
        });
      })
      .catch(function (e) {
        console.warn('[Feürzi] Synchronisation impossible :', e);
      })
      .then(function () {
        enCours = false;
      });
  }

  /* ------------------------------------------------------------------ *
   *  Démarrage
   * ------------------------------------------------------------------ */

  function demarrer() {
    if (!document.querySelector('.feurzi-rewards2__data')) return;
    synchroniser();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /*
   * Dawn reconstruit entièrement le contenu du tiroir (renderContents) à chaque
   * ajout au panier : nos étiquettes et nos menus sont alors effacés. On observe
   * donc le DOM du panier pour les remettre — plutôt que d'intercepter le réseau
   * (essayé, cela provoquait des boucles de requêtes avec les autres apps panier).
   */
  function surveillerPanier() {
    if (typeof MutationObserver === 'undefined') return;

    var minuteur = null;
    var observateur = new MutationObserver(function () {
      if (decorationEnCours || enCours) return; // nos propres écritures
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        if (!document.querySelector('.feurzi-rewards2__data')) return;
        synchroniser();
      }, 250);
    });

    // `main-cart-footer` est inclus car la barre de la page /cart y vit désormais.
    ['#CartDrawer', '#main-cart-items', '#main-cart-footer'].forEach(function (selecteur) {
      var noeud = document.querySelector(selecteur);
      if (noeud) observateur.observe(noeud, {childList: true, subtree: true});
    });
  }

  surveillerPanier();
})();
